module.exports = __webpack_public_path__ + "static/media/ios-share.c802f558.svg";